export enum SETTINGS_ACTIONS_NAMES {
  'DARK_MODE_CHANGED' = '[SETTINGS] DARK_MODE_CHANGED',
}
